<template>
	<div class="form-group">
		<slot name="header"></slot>	
		<password-group @change="emit('input', code)" v-model="code" id="code" name="code"
		                :placeholder="'Enter Your code' | trans"
		                :className="status(v)"
		                :reset="resetcode"
		                :lock="lock"
		                keyboard="true">
			<ul class="codeGroup__messages invalid-feedback list-unstyled" v-if="v.$error">
				<li v-if="!v.required">
					{{'code required' | trans}}
				</li>
				<li v-if="!v.minLength">
					{{'code length must be at least 4 characters' | trans}}
				</li>
				<li v-if="!v.maxLength">
					{{'code length may not be greater than 4 characters' | trans}}
				</li>
				<li v-if="!v.integer">
					{{'code must contain only digits' | trans}}
				</li>
			</ul>
		</password-group>
		<form-errors :field-name="'code'" />
		<div class="form-group form__item" v-if="!hidecodeButton">
			<div class="clearfix">
				<div class="float-left" v-if="cancelButton">
					<b-button @click.prevent="$emit('codeDialogCancel', $event)"
					          :disabled="lock">{{'Cancel' | trans}}</b-button>
				</div>
				<div class="float-right">
					<spinner-button :className="'btn btn-danger'" @click.prevent="$emit('codeSubmit', $event)"
					                :is-pending="lock">
						{{'Validate Code' | trans}}
					</spinner-button>
				</div>
			</div>
		</div>
		<div v-else>
			{{'Please wait ...' | trans}}
		</div>
		<slot name="footer"></slot>
	</div>
</template>

<script>
	export default {
		props: ['v', 'lock'],
		data() {
			return {
				code: '',
				resetcode: false
			}
		},
		watch: {
			code() {
				this.$emit('input', this.code)
			},
		},
		methods: {
			input(data) {
				this.$emit('input', data);
			}
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/code-verify.vue